// extracted by mini-css-extract-plugin
module.exports = {"gygTourCardImage":"providers-gyg-components-GygTourCard-GygTourCardImage-GygTourCardImage__gygTourCardImage--3Z4El"};